/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from 'react';

import { CgTrashEmpty } from 'react-icons/cg';
import { HiOutlinePencil } from 'react-icons/hi';

import Button from '../../../../newComponents/Button';

import * as S from './styles';

import { calcOrderPrice } from '../../../../utils/calcOrderPrice';
import { formateBrPrice } from '../../../../utils/formateBrPrice';
import { ICartItem } from '../../../../interfaces/ICartItem';

interface CartItemProps {
  item: ICartItem;
  removeItemToCart: () => void;
  editItem: () => void;
}

const Cart: React.FC<CartItemProps> = ({
  item,
  editItem,
  removeItemToCart,
}) => {
  const [amountOfFlavors, setAmountOfFlavors] = useState(0);

  useEffect(() => {
    let qtdTemp =
      1 /
      Math.min(
        ...item.childOrderItems.map((produto: any) => produto.quantidade),
      );

    if (1 - qtdTemp > 0.002) {
      let i = 2;
      while ((qtdTemp * i) % 1 !== 0) {
        i++;
      }
      qtdTemp *= i;
    }

    setAmountOfFlavors(qtdTemp);
  }, [item.childOrderItems]);

  return (
    <S.Container key={item.id}>
      <div className="header">
        <p>{item.quantity}</p>
        <span
          title={
            item.compositeProduct.product.controlGrid === 2
              ? item.childOrderItems.length > 1 &&
                Number(item.compositeProduct.product.controlGrid) === 2
                ? item.size !== null
                  ? `Pizza ${item.size}`
                  : `Pizza`
                : `${item.compositeProduct.product.name} ${item.size || ''}`
              : item.gridProduct &&
                item.compositeProduct.product.controlGrid === 1
              ? `${item.compositeProduct.product.name} - ${item.gridProduct.name}`
              : `${item.compositeProduct.product.name}`
          }
        >
          {item.compositeProduct.product.controlGrid === 2
            ? item.childOrderItems.length > 1 &&
              Number(item.compositeProduct.product.controlGrid) === 2
              ? item.size !== null
                ? `Pizza ${item.size}`
                : `Pizza`
              : `${item.compositeProduct.product.name} ${item.size}`
            : item.gridProduct &&
              item.compositeProduct.product.controlGrid === 1
            ? `${item.compositeProduct.product.name} - ${item.gridProduct.name}`
            : `${item.compositeProduct.product.name}`}
        </span>
        <p>{formateBrPrice(calcOrderPrice(item))}</p>
        <div className="buttons">
          <Button onClick={editItem}>
            <HiOutlinePencil />
          </Button>
          <Button onClick={removeItemToCart}>
            <CgTrashEmpty />
          </Button>
        </div>
      </div>
      {item.compositeProduct.complements.length ||
      item.childOrderItems.length > 1 ||
      item.observation.length ? (
        <div className="complements">
          {item.compositeProduct.complements.length ||
          item.childOrderItems.length > 1 ? (
            <>
              {item.childOrderItems.length > 1 &&
                item.childOrderItems.map((produto: any) => (
                  <div className="items">
                    <span key={produto.produto.id}>
                      {`${Math.round(
                        produto.quantidade * amountOfFlavors,
                      )}/${Math.round(amountOfFlavors)} ${
                        produto.produto.name
                      }`}
                    </span>
                    <div />
                    <span>
                      {formateBrPrice(
                        produto.quantidade *
                          (Number(produto.produto.grids[0].price.value) -
                            Number(
                              produto.produto.grids[0].discount?.price || 0,
                            )),
                      )}
                    </span>
                  </div>
                ))}
              {item.compositeProduct.complements.map((complemento) => (
                <div className="items" key={complemento.complement.id}>
                  <span
                    title={`${+complemento.quantity} ${
                      complemento.complement.name
                    }`}
                  >
                    {`${+complemento.quantity} ${complemento.complement.name}`}
                  </span>
                  <div />
                  <span>
                    {formateBrPrice(
                      complemento.quantity *
                        +complemento.complement.price.value,
                    )}
                  </span>
                </div>
              ))}
            </>
          ) : (
            <></>
          )}
          {item.observation && item.observation !== '' && (
            <p title={item.observation}>Obs: {item.observation}</p>
          )}
        </div>
      ) : (
        <></>
      )}
    </S.Container>
  );
};

export default Cart;
